export default __webpack_public_path__ + "static/media/Bright.49f1fce7.PNG";